import type theme from '#build/ui/tooltip'
import type { DeepPartial } from '@nuxt/ui'

const tooltip: DeepPartial<typeof theme> = {
  slots: {
    content: [
      'bg-cvt-burgundy-600 ring-cvt-burgundy-500 dark:bg-cvt-burgundy-100 dark:text-cvt-text-darker dark:ring-cvt-burgundy-300 z-50 flex max-w-[184px] select-none items-center gap-1 rounded-sm px-2 py-1 text-xs text-white shadow-md ring-2 h-auto',
      'animate-in fade-in-0 zoom-in-100 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
    ] as any,
    arrow: 'fill-cvt-burgundy-500 dark:fill-cvt-burgundy-300',
    text: 'text-center whitespace-normal overflow-visible',
  },
}

export default tooltip
